export default __webpack_public_path__ + "static/media/meal.6bc4fe13.svg";